import React from 'react'
import { useTranslation } from 'next-i18next'
import Image from '../../../Image'

type UserTestimonialCardProps = {
  fileName: string
  title: string
  subtitle: string
}

export default function UserTestimonialCard({
  fileName,
  title,
  subtitle,
}: UserTestimonialCardProps) {
  const { t } = useTranslation('originals/property')

  return (
    <>
      <div className="h-11 w-full sm:h-7"></div>
      <div className="relative rounded-2xl bg-neutralWhite p-2.5">
        <div className="absolute -top-14 left-1/2 z-10 aspect-square h-36 -translate-x-1/2 overflow-hidden rounded-full bg-purpleGradient shadow-xl">
          <Image
            dir="/img/photos/people/"
            fileName={fileName}
            className="absolute bottom-[11px] left-1/2 z-10 -translate-x-1/2 scale-[120%]"
            alt={title}
            lazyLoading
          />
        </div>

        <div className="h-20"></div>

        <div className="mb-3 border-b border-neutralGray/30 pb-3">
          <p className="text-center text-xs font-medium text-neutralBlack/80">
            {title}
          </p>
          <p className="text-center text-xs font-light text-neutralBlack/80">
            {subtitle}
          </p>
        </div>

        <div className="px-0 lg:px-3 xl:px-6 2xl:px-10">
          <p className="text-center text-sm font-normal text-neutralBlack/90">
            {t('plateroTestimonialCard.text')}
          </p>
        </div>
      </div>
    </>
  )
}
